module.exports = __webpack_public_path__ + "static/media/120.def83ae2.jpg";